// extracted by mini-css-extract-plugin
export default {"animation":"Nickname__animation--1qz3B","imageMobile":"Nickname__imageMobile--s2UMO","animationMobile":"Nickname__animationMobile--SdfLC"};